import { render, staticRenderFns } from "./TextModerationRulesManagement.vue?vue&type=template&id=5dd2cdb6&"
import script from "./TextModerationRulesManagement.vue?vue&type=script&lang=js&"
export * from "./TextModerationRulesManagement.vue?vue&type=script&lang=js&"
import style0 from "./TextModerationRulesManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports